import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
declare var $: any;
import * as _ from 'lodash';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
import { NcdtermsheetService } from 'src/app/services/NCD/ncdtermsheet.service';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-issues-list',
  templateUrl: './issues-list.component.html',
  styleUrls: ['./issues-list.component.css']
})
export class IssuesListComponent implements OnInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtIssueList: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  allNcdIssueList: any;
  securityName: any;
  securityNameArray: any = [];
  partAList: any = [];
  partBList: any = [];
  securityNameList: any = [];
  deleteIssue: any;
  isSearchDivVisible = false;

  termsheetArray: any = [];
  termsheetHeader: any = [];
  checkTSAvailable: any = [];

  addFieldarrayHeader: any = [];
  addFieldarrayValues: any = [];

  cashFlowHeadersForCoupon: any = [];
  cashFlowHeadersForPrincipal: any = [];
  cashflowValueArray: any = [];

  financialYears: any = [];
  TodayDate: NgbDateStruct;
  currentYear: any;

  // search Variables
  securedUnsecuredValue: any = '';
  financialYearModel: any = '';
  faceValueModel: any = '';
  allotmentDateModel: any = '';
  maturityDateModel: any = '';
  drawnAmountModel: any = '';
  // creditRatingAgencyModel: any = '';
  selectedFinancialYear: any = '';
  selectedListing: any = '';
  selectedIssueType: any = '';

  // MASTER
  termsheetDataListArray: any = [];
  listOfValuesArray: any = [];
  dropdownList: any = [];


  constructor(private ncdClientService: NcdclientService, private ncdTermsheetService: NcdtermsheetService, 
    private router: Router, private alert: AlertComponent,private route: ActivatedRoute) { }

  ngOnInit() {

    var targetsArray = [];
    for (let i = 5; i < 92; i++) {
      targetsArray.push(i);
    }

    var targetsArrayForExportBtn = [];
    for (let j = 0; j < 92; j++) {
      if (j != 1 && j != 2 && j != 3 && j != 4) {
        targetsArrayForExportBtn.push(j);
      }

    }
    this.dtIssueList = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      autoWidth: false,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }, { className: "hide_col", targets: targetsArray }],
      // columnDefs: [{ orderable: false, targets: [4] }, { className: "hide_col", targets: [5,6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'NCD-Issue List',
          title: 'NCD-Issue List',
          extend: 'excel',
          exportOptions: {
            columns: targetsArrayForExportBtn,
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
            // columns: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92]
          }
        }
      ]
    };

    this.getAllNcdIssueList({ isSearch: false });
    this.getTermsheetDataList();



    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear() - 10;
    this.TodayDate = { year: year, month: month, day: day };

    this.currentYear = year;

    for (let i = 0; i <= 20; i++) {
      var years = this.currentYear + i;
      var financialYears = years + "-" + (years + 1);
      this.financialYears.push(financialYears);

    }

  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setDatesInFormat(date) {
    if (date != null) {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      var dateObj = { day: days[new Date(date).getDay()], year: new Date(date).getFullYear(), month: months[new Date(date).getMonth()], date: new Date(date).getDate() };
      return dateObj.day + ", " + dateObj.month + " " + dateObj.date + ", " + dateObj.year
    }
    return null;
  }

  getAllNcdIssueList(object) {
    const destroyAndReload = () => {
      this.ncdClientService.getAllIssueListData(object).subscribe((response:any) => {

        var ncdIssues = response.data;
        this.allNcdIssueList = ncdIssues;

      if (this.allNcdIssueList && this.allNcdIssueList.length) {

        this.cashflowValueArray = [];
        var self = this;

        // Additional Field Header
        this.addFieldarrayHeader = response.datatableHeaders.additionalTab;
        //  =========================================================================

        // Termsheet Header --------------------------------------------------------
        this.termsheetHeader = response.datatableHeaders.termsheet;
        // ----------------------------------------------------------------------------

        // Indexes of conditional (date) fields ----------------------------------------------
        var addFieldarrayHeaderCopy = []; var indexOfConditionalFieldsArray = [];
        addFieldarrayHeaderCopy = this.addFieldarrayHeader;
        _.forEach(addFieldarrayHeaderCopy, function (element) {
          if (element == "imDate" || element == "CreditRatingLetterDate_1" || element == "CreditRatingLetterDate_2" || element == "CreditRatingLetterDate_3" || element == "CreditRatingLetterDate_4" || element == "ListingDate" || element == "DebentureTrusteeAgreementDate" || element == "DeedOfHypothecationDate" || element == "SimpleMortgateDeedDate" || element == "DebentureTrusteeConsentDate" || element == "DateOfSigningApprovalLetter" || element == "DateOfIntimationToStockExchange" || element == "AllotmentLetterDate" || element == "DateOfMasterCreationFormCDSL_NSDL" || element == "DebentureTrustDeedDate") {
            indexOfConditionalFieldsArray.push(element);
          }
        })
        // ----------------------------------------------------------------------------


        var AdditionalFieldsArray;
        for (let i = 0; i < this.allNcdIssueList.length; i++) {

          // Additional Fields VAlue---------------------------------------------------
          AdditionalFieldsArray = [];
          AdditionalFieldsArray = this.allNcdIssueList[i].issuedata.AdditionalFields;
          // if (AdditionalFieldsArray != undefined && AdditionalFieldsArray != null) {
          var result = [];
          var resultObj;
          result = Object.keys(AdditionalFieldsArray).map(function (key) {
            resultObj = {
              key: key,
              value: AdditionalFieldsArray[key]
            }
            return resultObj;
          });

          this.addFieldarrayValues[i] = [];
          _.forEach(result, function (item) {
            var addFieldsObj = '';
            if (item.key != 'dynamicFieldsArray') {
              if (item.value == null || item.value == '' || item.value == undefined) {
                addFieldsObj = ' '
              } else {
                if (_.includes(indexOfConditionalFieldsArray, item.key)) {
                  addFieldsObj = self.setDatesInFormat(item.value);
                } else {
                  addFieldsObj = item.value;
                }
              }
              self.addFieldarrayValues[i].push(addFieldsObj);
            }
          });

          // Termsheet VALUES ============================================================
          this.termsheetArray[i] = [];
          if (this.allNcdIssueList[i].issuedata.IssueCreatedStatus == "save&create") {
            for (let k = 0; k < this.termsheetHeader.length; k++) {
              // if (this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName != 'Deemed Date of Allotment') {
              var defaultVal;
              if (this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].InputType == 'Date') {
                // use to know the number is only integer number or not in true or fale result: /^\d+$/.test(this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].DefaultValue 
                if (this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Redemption Date' || this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Pay-in Date' || this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Deemed Date of Allotment') {
                  let arr = this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].DefaultValue.split(',');
                  var self = this;
                  arr = arr.map(function (ele, index) {
                    ele = self.setDatesInFormat(new Date(Number(ele)));
                    return ele;
                  })
                  defaultVal = arr.join(",  ")

                } else {
                  defaultVal = this.setDatesInFormat(new Date(this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].DefaultValue));
                }
              } else {
                if (this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k] == undefined || this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].DefaultValue == '') {
                  defaultVal = ' ';
                } else {
                  if (this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Redemption Amount' || this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Issue Price' || this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Face Value') {
                    var splitArray = [];
                    splitArray = (this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].DefaultValue).split(",");
                    var self = this;
                    _.forEach(splitArray, function (elem, index) {
                      if (self.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Redemption Amount') {
                        splitArray[index] = self.addCommas(elem) + " " + 'Crs';
                      } else if (self.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].FieldName == 'Issue Price') {
                        splitArray[index] = self.addCommas(elem) + " " + '/-';
                      } else {
                        splitArray[index] = self.addCommas(elem);
                      }
                    });

                    let valueWithCommas = splitArray.join(",  ");
                    defaultVal = valueWithCommas;
                  } else {
                    defaultVal = this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray[k].DefaultValue;
                  }
                }
              }
              var termsheetArraySpecificFields = {
                DefaultValue: defaultVal
              }
              this.termsheetArray[i].push(termsheetArraySpecificFields);
              // }
            }
          } else {
            for (let k = 0; k < this.termsheetHeader.length; k++) {
              let termsheetArraySpecificFields = {
                DefaultValue: ' '
              }
              this.termsheetArray[i].push(termsheetArraySpecificFields);
            }
          }

          if (this.allNcdIssueList[i].Termsheet.length > 0) {
            if (this.termsheetHeader.length > this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray.length) {
              var extraLength = this.termsheetHeader.length - this.allNcdIssueList[i].Termsheet[0].termSheetFieldArray.length;
              for (let len = 0; len < extraLength; len++) {
                let termsheetArraySpecificFields = {
                  DefaultValue: ' '
                }
                this.termsheetArray[i].push(termsheetArraySpecificFields);
              }
            }
          }

        }
        // ==================================================================


        // CASHFLOW ===================================================
        // cashflow HEADER---------------------------------------------
        var cashFlowObject;
        for (let i = 0; i < this.allNcdIssueList.length; i++) {
          if (this.allNcdIssueList[i].issuedata.IssueCreatedStatus == "save&create" && this.allNcdIssueList[i].Termsheet.length > 0 && this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0] != null) {
            // if (this.allNcdIssueList[i].Termsheet.length > 0 && this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0] != null) {
              // cashflow CouponPaymentDate
                var cashflowCouponPaymentDate = this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0].coupon;
                var couponPaymentDateArray = []; var couponPayoutDateArray = [];
                _.forEach(cashflowCouponPaymentDate, function (element) {
                  couponPaymentDateArray.push(element.CouponPaymentDate);
                  if (self.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0].cashFlowType == 'Compounded Interest') {
                    couponPayoutDateArray.push(' ');
                  } else {
                    couponPayoutDateArray.push(element.CouponPayoutDate);
                  }
                })

                let couponPaymentDateString = couponPaymentDateArray.join(",   ");
                let couponPayoutDateString
                if (this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0].cashFlowType != 'Compounded Interest') {
                  couponPayoutDateString = couponPayoutDateArray.join(",   ");
                } else {
                  couponPayoutDateString = ' ';
                }

                let princiPayOutDate;
                if (this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0].cashFlowType == 'Compounded Interest') {
                  princiPayOutDate = ' ';
                } else {
                  princiPayOutDate = this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0].principalCalculation.PrincipalPayoutDate
                }
                cashFlowObject = {
                  couponPaymentDate: couponPaymentDateString,
                  couponPayoutDate: couponPayoutDateString,
                  principalDueDateForPayment: this.allNcdIssueList[i].Termsheet[0].cashflowCalculations[0].principalCalculation.PrincipalDueDateForPayment,
                  principalPayoutDate: princiPayOutDate
                }

                this.cashflowValueArray.push(cashFlowObject);
            // }
          } else {
            cashFlowObject = {
              couponPaymentDate: ' ',
              couponPayoutDate: ' ',
              principalDueDateForPayment: ' ',
              principalPayoutDate: ' '
            }
            this.cashflowValueArray.push(cashFlowObject);
          }
        }

      }
      // Use setTimeout to ensure DOM is ready before triggering DataTables
      setTimeout(() => {
        if (this.dtElement && this.dtElement.dtInstance) {
          this.dtTrigger.next();
        }
      }, 100);
    });
    };

    // Properly destroy existing DataTable before reloading
    if (this.dtElement && this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        // Wait for destroy to complete before reloading
        setTimeout(() => {
          destroyAndReload();
        }, 50);
      }).catch(() => {
        // If destroy fails, proceed anyway
        destroyAndReload();
      });
    } else {
      // No existing instance, proceed directly
      destroyAndReload();
    }
  }
 add(){
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['ncd-issue','add']  } }],
    { relativeTo: this.route.parent }
  );
 }
  loadncdIssueByID(issueId) {
    // console.log(issueId)
    // this.router.navigate(['/ncd-issue/edit', JSON.stringify(issueId)]);

    this.router.navigate( [{ outlets: { 'structure-outlet': ['ncd-issue','edit',JSON.stringify(issueId)]  } }],
    { relativeTo: this.route.parent });
  }

  confirmDelete(id) {
    this.deleteIssue = id;
    $("#confirmDeleteIssue").modal('toggle');
  }

  deleteNcdIssue() {
    this.ncdClientService.removeIssue(this.deleteIssue)
      .subscribe(response => {
        if (response.body.status == 0) {
          this.alert.success(response.body.message);
        } else {
          this.alert.error(response.body.message);
        }
        this.getAllNcdIssueList({ isSearch: false });
      });
  }

  doAdvSearch() {

    if (this.securedUnsecuredValue == '' && this.faceValueModel == '' && (this.allotmentDateModel == '' || this.allotmentDateModel == null) && (this.maturityDateModel == '' || this.maturityDateModel == null) && this.drawnAmountModel == '' && this.selectedFinancialYear == '' && this.selectedListing == '' && this.selectedIssueType == '') {
      this.alert.success("Fill atleast one search field");
    } else {

      var searchnewFieldObject = {
        'security': this.securedUnsecuredValue,
        'faceValue': this.faceValueModel,
        'payinDate': this.setDate(this.allotmentDateModel),
        'redemptionDate': this.setDate(this.maturityDateModel),
        'drawnAmount': this.drawnAmountModel,
        'financialYear': this.selectedFinancialYear,
        'EBPPlatform': this.selectedListing,
        // 'creditRatingAgency': this.creditRatingAgencyModel,
        'modeofIssue': this.selectedIssueType,
        'isSearch': true
      }
      this.getAllNcdIssueList(searchnewFieldObject);
    }
  }

  clearAdvSearch() {
    this.securedUnsecuredValue = '';
    this.faceValueModel = '';
    this.allotmentDateModel = '';
    this.maturityDateModel = '';
    this.drawnAmountModel = '';
    this.selectedFinancialYear = '';
    this.selectedListing = '';
    // this.creditRatingAgencyModel = '';
    this.selectedIssueType = '';
    // this.doAdvSearch();
    this.getAllNcdIssueList({ isSearch: false });
  }

  selectSecuredUnsecured(ev) {
    this.securedUnsecuredValue = ev.target.value;
  }

  selectFinancialYr(ev) {
    this.selectedFinancialYear = ev.target.value;
  }

  selectListing(ev) {
    this.selectedListing = ev.target.value;
  }

  selectIssueType(ev) {
    this.selectedIssueType = ev.target.value;
  }

  // MASTER
  getTermsheetDataList() {
    this.termsheetDataListArray = [];
    this.ncdTermsheetService.getTermsheetData({ isSearch: false }).subscribe((termsheetList:any) => {
      this.termsheetDataListArray = termsheetList.data;

      var self = this;
      var count = 0;
      _.forEach(this.termsheetDataListArray, function (fieldList) {
        if (fieldList.FieldName == "Security" || fieldList.FieldName == "Mode of Issue" || fieldList.FieldName == "EBP Platform") {
          self.dropdownList[fieldList.FieldName] = [];
          self.listOfValuesArray = fieldList.ListOfValues;
          for (let i = 0; i < self.listOfValuesArray.length; i++) {
            var valueList = self.listOfValuesArray[i]['newFieldValue' + i]
            self.dropdownList[fieldList.FieldName].push(valueList);
          }
        }

      })
    });
  }
}
